import { connect } from "react-redux";
import { cloneDeep } from "lodash";

import Select from "react-select";

import { PlusCircleIcon, MinusCircleIcon } from "@heroicons/react/20/solid";

import { Actions as ACTIONS } from '../../../store/actions/leaveActions';

const payOptions = [
    { value: "basic", label: "Basic Pay" },
    { value: "holidayPay", label: "Holiday Pay" },
];


const OccupationalLeaveRuleEntitlement = ({
	updateField,
	addPart,
	removePart,
	entitlement,
	partIndex,
	lastPart,
	currency,
}) => {
	return (
		<div className={`col-xs-12 ${partIndex ? 'p-0 pt-5' : 'p-0'}`}>
			<div className="col-xs-1 p-0">
				{partIndex > 0 ? (
					<label className={"pull-right"}>Followed By</label>
				): <label className={"pull-right"}></label>}
			</div>
			<div className="col-xs-10">
                <div
                    className="input-group"
                    style={{zIndex: 100 - partIndex}}
                >
                    <input
                        type="number"
                        className="form-control"
                        style={{ height: "39px", minWidth: "30px", paddingLeft: 10 }}
                        value={entitlement?.qty}
                        onChange={(e) => {
                            updateField("qty", e.target.value);
                        }}
                    />
                    <span
                        className={`input-group-addon "}`}
                        style={{
                            padding: "0 5px",
                            border: "none",
                            lineHeight: "38px",
                            width: "29px",
                            textAlign: "center",
                            userSelect: "none",
                        }}
                    >
                        <span style={{ width: "100%", userSelect: "none" }}>days paid at</span>
                    </span>
                    <input
                        type="number"
                        className="form-control"
                        style={{ height: "39px", minWidth: "30px", paddingLeft: 10 }}
                        value={entitlement?.amount}
                        onChange={(e) => {
                            updateField("amount", e.target.value);
                        }}
                    />
                    <span
                        className={`input-group-addon "}`}
                        style={{
                            padding: "0 5px",
                            border: "none",
                            lineHeight: "38px",
                            width: "29px",
                            textAlign: "center",
                            userSelect: "none",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            updateField("percentage", entitlement?.percentage ? false : true);
                        }}
                    >
                        <span style={{ width: "100%", userSelect: "none" }}>{
                            entitlement?.percentage ? "% of" : currency
                        }</span>
                    </span>
                    {
                        entitlement?.percentage && (
                            <Select
                                name="Is"
                                isClearable={true}
                                isMulti={false}
                                options={payOptions}
                                placeholder="Choose One"
                                styles={{
                                    control: (styles) => ({
                                        ...styles,
                                        float: "left",
                                    }),
                                }}
                                value={payOptions?.find((i) => entitlement?.payMethod?.includes(i.value))}
                                onChange={(e) => {
                                    updateField("payMethod", e.value || null);
                                }}
                            />
                        )
                    }

                </div>
			</div>
			<div className="col-xs-1"
				 style={{
					display: "flex",
					padding: 0,
					// justifyContent: "space-between",
					justifyContent: "flex-end",
					 marginTop: '0.5em'
				 }}
			>
				<button
					className="btn btn-danger pull-left"
					style={{ padding: 3 }}
					type="button"
					onClick={() => removePart()}
				>
					<MinusCircleIcon style={{ height: "1.3em", float: "left" }} />
				</button>
				{ lastPart && (
					<button
						className="btn btn-success pull-left"
						style={{ padding: 3 }}
						type="button"
						onClick={() => addPart()}
					>
						<PlusCircleIcon
							style={{ height: "1.3em", float: "left"}}
						/>
					</button>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state,ownProps) => {

    const currency = state?.company?.settings?.currency

	return {
		currency,
	}

};

const mapDispatchToProps = (dispatch,ownProps) => ({
	updateField: (field, value) => dispatch(ACTIONS.updateLeaveRule({
        field: `entitlements.${ownProps.partIndex}.${field}`,
        value,
        id: ownProps?.id
    })),
	addPart: () => dispatch(ACTIONS.updateLeaveRule({
        field: `entitlements.${ownProps.partIndex + 1}`,
        value: {},
        id: ownProps?.id
    })),
	removePart: () => dispatch(ACTIONS.updateLeaveRule({
        field: `entitlements.${ownProps.partIndex}`,
        action: "remove",
        id: ownProps?.id
    })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OccupationalLeaveRuleEntitlement);
